// @flow

import type {State} from 'redux/types';
import type {CcState} from 'redux/v1/paymentTravel/cc/CcState';
import type {DeleteState} from 'redux/v1/paymentTravel/delete/DeleteState';
import type {DeletePaypalState} from 'redux/v1/paymentTravel/deletePaypal/DeletePaypalState';
import type {IframeState} from 'redux/v1/paymentTravel/iframe/IframeState';
import type {InvoiceState} from 'redux/v1/paymentTravel/invoice/InvoiceState';
import type {PaymentTypesState} from 'redux/v1/paymentTravel/paymentTypes/PaymentTypesState';
import type {PaypalState} from 'redux/v1/paymentTravel/paypal/PaypalState';
import type {PaypalVaultState} from 'redux/v1/paymentTravel/paypalVault/PaypalVaultState';
import type {SelectedPaymentState} from 'redux/v1/paymentTravel/selectedPayment/SelectedPaymentState';
import type {SepaState} from 'redux/v1/paymentTravel/sepa/SepaState';

import {paymentTravelState} from 'redux/v1/V1State';

export type PaymentTravelState = {
  paymentTypes: PaymentTypesState,
  invoice: InvoiceState,
  cc: CcState,
  iframe: IframeState,
  sepa: SepaState,
  paypal: PaypalState,
  deletePaypal: DeletePaypalState,
  paypalVault: PaypalVaultState,
  selectedPayment: SelectedPaymentState,
  delete: DeleteState,
};

export const paymentTypesState = (state: State): PaymentTypesState =>
  paymentTravelState(state).paymentTypes;

export const invoiceState = (state: State): InvoiceState =>
  paymentTravelState(state).invoice;

export const ccState = (state: State): InvoiceState =>
  paymentTravelState(state).cc;

export const iframeState = (state: State): IframeState =>
  paymentTravelState(state).iframe;

export const sepaState = (state: State): SepaState =>
  paymentTravelState(state).sepa;

export const paypalState = (state: State): PaypalState =>
  paymentTravelState(state).paypal;

export const deletePaypalState = (state: State): DeletePaypalState =>
  paymentTravelState(state).deletePaypal;

export const paypalVaultState = (state: State): PaypalVaultState =>
  paymentTravelState(state).paypalVault;

export const selectedPaymentState = (state: State): SelectedPaymentState =>
  paymentTravelState(state).selectedPayment;

export const deleteState = (state: State): DeleteState =>
  paymentTravelState(state).delete;
